export default async (scheme, typeScheme) => {
  const { properties = {} } = scheme;
  const { type } = properties;

  // добавляем значение типа схемы
  // для отображения нужной при множественном кол-ве схем
  if (typeScheme && type) {
    type.value = typeScheme;
  }

  return scheme;
};
